export const API_HOST = process.env.REACT_APP_API_HOST || 'https://tinkrverse.io/api';